
/**
 * 강의 난이도
 */
export type GetCourse200SummaryLevel = typeof GetCourse200SummaryLevel[keyof typeof GetCourse200SummaryLevel];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetCourse200SummaryLevel = {
  BEGINNER: 'BEGINNER',
  INTERMEDIATE: 'INTERMEDIATE',
  ADVANCED: 'ADVANCED',
  ALL: 'ALL',
} as const;
